import React from "react";

import svg from "../../assets/images/icons/file_upload.svg";

export const FileUploadIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "File Upload"}
    />
);
